import type { Capability } from '../types'
import type { Locale } from '../i18n'

export function detectCapabilities(locale: Locale = 'en'): Capability[] {
  const detail = {
    en: ['Local media engine', 'Background processing', 'Native browser codecs', 'Direct save for large files', 'Required for the MT core; ST fallback remains available'],
    zh: ['本地媒体引擎', '后台处理', '浏览器原生编解码', '大文件直接保存', 'MT 核心所需；不满足时使用 ST 回退'],
    ja: ['ローカルメディアエンジン', 'バックグラウンド処理', 'ブラウザ標準コーデック', '大容量ファイルの直接保存', 'MTコアに必要。未対応時はSTへフォールバック'],
  }[locale]
  const names = {
    en: ['WebAssembly', 'Worker', 'WebCodecs', 'Direct file writing', 'Multi-thread isolation'],
    zh: ['WebAssembly', 'Worker', 'WebCodecs', '文件直写', '多线程隔离'],
    ja: ['WebAssembly', 'Worker', 'WebCodecs', 'ファイル直接保存', 'マルチスレッド分離'],
  }[locale]
  return [
    {
      name: names[0],
      supported: typeof WebAssembly === 'object',
      detail: detail[0],
    },
    {
      name: names[1],
      supported: typeof Worker !== 'undefined',
      detail: detail[1],
    },
    {
      name: names[2],
      supported: 'VideoEncoder' in window && 'AudioEncoder' in window,
      detail: detail[2],
    },
    {
      name: names[3],
      supported: typeof window.showSaveFilePicker === 'function',
      detail: detail[3],
    },
    {
      name: names[4],
      supported: window.isSecureContext
        && window.crossOriginIsolated
        && typeof SharedArrayBuffer !== 'undefined'
        && typeof Worker !== 'undefined',
      detail: detail[4],
    },
  ]
}

export function canProcess(capabilities: Capability[]): boolean {
  return capabilities.slice(0, 2).every((item) => item.supported)
}
